import React, { useEffect, useState } from "react";
import Header from "components/Header/index";

import { Col, Collapse, message, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { sectorListingParent } from "services/remanentCalls";
import { tenderTypeListing } from "services/redux/Reference/Tender/action";
import { isEmpty } from "lodash";

const { Panel } = Collapse;

const RotoCircularTemplate = () => {
  const { tenderTypeListingResponse, tenderSubTypeListingResponse } =
    useSelector((state) => state.tender);
  const dispatch = useDispatch();
  // column collapsible
  const [isLeftColumnCollapsible, setIsLeftColumnCollapsible] = useState(true);
  const [selectedProjectId, setSelectedProjectId] = useState();

  const [typeListing, setTypeListing] = useState([]);
  const [sectors, setSectors] = useState([]);

  useEffect(() => {
    dispatch(tenderTypeListing());
    fetchAllSector();
  }, []);

  useEffect(() => {
    if (!isEmpty(tenderTypeListingResponse)) {
      setTypeListing(tenderTypeListingResponse);
    }
  }, [tenderTypeListingResponse]);

  const fetchAllSector = async () => {
    const resp = await sectorListingParent().catch((err) => {
      message.error("Failure");
    });

    if (resp && resp.status === 200) {
      setSectors(resp.data);
    }
  };

  const animateDiv = {
    opacity: isLeftColumnCollapsible ? 1 : 0,
    transition: "opacity 0.5s ease",
  };

  const renderNameOrNA = (name) => name || "0";

  return (
    <div className="layout">
      <div className="organizer contacts">
        <div className="contactDetails__split">
          {/* <div className="contactDetails__split--pagination side-bg-header-wrapper"> */}
          <div
            className={`side-bg-header-wrapper ${
              isLeftColumnCollapsible
                ? "contactDetails__split--pagination"
                : "contactDetails__split--pagination-collapse"
            } `}
          >
            <Header
              isLeftColumnCollapsible={isLeftColumnCollapsible}
              setIsLeftColumnCollapsible={setIsLeftColumnCollapsible}
            />

            <div style={animateDiv}>
              <Row
                gutter={[8, 8]}
                style={{ marginTop: "-12px", height: "36%" }}
              >
                <Col span={24}>
                  <div className="profiledetails">
                    <Collapse
                      expandIconPosition="right"
                      defaultActiveKey={["1"]}
                      accordion={true}
                      // activeKey={activeKey}
                    >
                      {typeListing?.map((type) => (
                        <Panel header={type.tenderTypeName} key={type.id}>
                          <div
                            id="tenderScroll"
                            style={{
                              overflowY: "auto",
                            }}
                          >
                            {!isEmpty(sectors) && (
                              <>
                                {sectors.map((data, i) => (
                                  <div
                                    style={{ background: "#f2f2f2" }}
                                    className={`project ${
                                      selectedProjectId === type.id + data.id &&
                                      "active"
                                    }`}
                                    onClick={() => {
                                      //   rowEventhandlersProject(data.id);
                                      setSelectedProjectId(type.id + data.id);
                                      //   setSearchEmailTender(data.referenceCode);
                                    }}
                                    key={data.id}
                                  >
                                    <div className="project__wrapper">
                                      <div className="project__wrapper--contents">
                                        <div className="project__body">
                                          <div className="project__body--right">
                                            <span className="project__body--code">
                                              {data.sectorName}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                          </div>
                        </Panel>
                      ))}
                    </Collapse>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div
            className={`${
              isLeftColumnCollapsible
                ? "contactDetails__split--right"
                : "contactDetails__split--right-collapse"
            }`}
          >
            <div className="referencetabs tabs-wrapper custom-tabs-wrapper"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RotoCircularTemplate;
